import PrintOrderDetails from './PrintOrderDetails';

export default PrintOrderDetails;
